"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.login = exports.defaultEmailValidator = void 0;
var validator_1 = __importDefault(require("validator"));
var types_1 = require("../actions/types");
var types_2 = require("../../app/util/types");
var defaultEmailValidator = function (email) {
    return validator_1.default.isEmail(email, { allow_utf8_local_part: false });
};
exports.defaultEmailValidator = defaultEmailValidator;
var initialState = {
    email: '',
    emailValidator: exports.defaultEmailValidator,
    user: {},
    isLoggedIn: false,
    formVariant: types_2.loginFormVariants.types.EMAIL_READY,
};
var login = function (state, action) {
    if (state === void 0) { state = initialState; }
    var nextState = {};
    switch (action.type) {
        case types_1.SET_EMAIL_VALIDATOR:
            nextState = {
                emailValidator: action.payload,
            };
            break;
        case types_1.GET_OTP_EMAIL_ERROR:
            nextState = {
                formVariant: types_2.loginFormVariants.types.EMAIL_READY,
            };
            break;
        case types_1.GET_OTP_EMAIL_PENDING:
            nextState = {
                formVariant: types_2.loginFormVariants.types.EMAIL_PENDING,
            };
            break;
        case types_1.GET_OTP_EMAIL_SUCCESS:
            nextState = {
                formVariant: types_2.loginFormVariants.types.OTP_READY,
                email: action.payload,
            };
            break;
        case types_1.VERIFY_OTP_ERROR:
            nextState = {
                formVariant: types_2.loginFormVariants.types.OTP_READY,
                isLoggedIn: false,
            };
            break;
        case types_1.VERIFY_OTP_PENDING:
            nextState = {
                formVariant: types_2.loginFormVariants.types.OTP_PENDING,
                isLoggedIn: false,
            };
            break;
        case types_1.RESEND_OTP_PENDING:
            nextState = {
                formVariant: types_2.loginFormVariants.types.OTP_PENDING,
            };
            break;
        case types_1.RESEND_OTP_DISABLED:
            nextState = {
                formVariant: types_2.loginFormVariants.types.RESEND_OTP_DISABLED,
            };
            break;
        case types_1.IS_LOGGED_OUT:
            nextState = {
                formVariant: types_2.loginFormVariants.types.EMAIL_READY,
                isLoggedIn: false,
                user: {},
            };
            break;
        case types_1.IS_LOGGED_IN_SUCCESS:
            nextState = {
                isLoggedIn: true,
                user: action.payload,
                formVariant: types_2.loginFormVariants.types.EMAIL_READY,
            };
            break;
        default:
            return state;
    }
    return __assign(__assign({}, state), nextState);
};
exports.login = login;
